import React, { useState } from "react";
import TransparentRoundedBtn from "../CTA/TransparentRoundedBtn";

function HealthcareTabs(props) {
  const [isActive, setIsActive] = useState(1);
  const handleActive = (btn) => setIsActive(btn);
  return (
    <div className="row">
      <div className="col-lg-6 col-md-12 mobOverflow">
        <div className="leftHealthTabBox ">
          <div
            className={`tabs tabs1 ${isActive === 1 ? "activeTab" : ""}`}
            onClick={() => handleActive(1)}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <g clipPath="url(#clip0_1826_200)">
                  <path
                    d="M15 15C15 14.558 15.1756 14.134 15.4882 13.8215C15.8007 13.5089 16.2246 13.3333 16.6667 13.3333H18.3333V11.6667C18.3333 11.2246 18.5089 10.8007 18.8215 10.4882C19.134 10.1756 19.558 10 20 10C20.442 10 20.8659 10.1756 21.1785 10.4882C21.4911 10.8007 21.6667 11.2246 21.6667 11.6667V13.3333H23.3333C23.7754 13.3333 24.1993 13.5089 24.5118 13.8215C24.8244 14.134 25 14.558 25 15C25 15.442 24.8244 15.8659 24.5118 16.1785C24.1993 16.4911 23.7754 16.6667 23.3333 16.6667H21.6667V18.3333C21.6667 18.7754 21.4911 19.1993 21.1785 19.5118C20.8659 19.8244 20.442 20 20 20C19.558 20 19.134 19.8244 18.8215 19.5118C18.5089 19.1993 18.3333 18.7754 18.3333 18.3333V16.6667H16.6667C16.2246 16.6667 15.8007 16.4911 15.4882 16.1785C15.1756 15.8659 15 15.442 15 15ZM26.6667 23.3333H13.3333C12.8913 23.3333 12.4674 23.5089 12.1548 23.8215C11.8423 24.134 11.6667 24.558 11.6667 25C11.6667 25.442 11.8423 25.8659 12.1548 26.1785C12.4674 26.4911 12.8913 26.6667 13.3333 26.6667H26.6667C27.1087 26.6667 27.5326 26.4911 27.8452 26.1785C28.1577 25.8659 28.3333 25.442 28.3333 25C28.3333 24.558 28.1577 24.134 27.8452 23.8215C27.5326 23.5089 27.1087 23.3333 26.6667 23.3333ZM20 30H13.3333C12.8913 30 12.4674 30.1756 12.1548 30.4882C11.8423 30.8007 11.6667 31.2246 11.6667 31.6667C11.6667 32.1087 11.8423 32.5326 12.1548 32.8452C12.4674 33.1577 12.8913 33.3333 13.3333 33.3333H20C20.442 33.3333 20.8659 33.1577 21.1785 32.8452C21.4911 32.5326 21.6667 32.1087 21.6667 31.6667C21.6667 31.2246 21.4911 30.8007 21.1785 30.4882C20.8659 30.1756 20.442 30 20 30ZM35 11.6667V31.6667C34.9974 33.876 34.1185 35.9941 32.5563 37.5563C30.9941 39.1185 28.876 39.9974 26.6667 40H13.3333C11.124 39.9974 9.00593 39.1185 7.4437 37.5563C5.88147 35.9941 5.00265 33.876 5 31.6667V11.6667C5.00265 9.45734 5.88147 7.33926 7.4437 5.77703C9.00593 4.2148 11.124 3.33598 13.3333 3.33333H13.6183C13.9643 2.35915 14.6032 1.51585 15.4473 0.919072C16.2915 0.322293 17.2995 0.00126125 18.3333 0L21.6667 0C22.7005 0.00126125 23.7085 0.322293 24.5527 0.919072C25.3968 1.51585 26.0357 2.35915 26.3817 3.33333H26.6667C28.876 3.33598 30.9941 4.2148 32.5563 5.77703C34.1185 7.33926 34.9974 9.45734 35 11.6667ZM31.6667 11.6667C31.6667 10.3406 31.1399 9.06881 30.2022 8.13113C29.2645 7.19345 27.9927 6.66667 26.6667 6.66667H25C24.558 6.66667 24.134 6.49107 23.8215 6.17851C23.5089 5.86595 23.3333 5.44203 23.3333 5C23.3333 4.55797 23.1577 4.13405 22.8452 3.82149C22.5326 3.50893 22.1087 3.33333 21.6667 3.33333H18.3333C17.8913 3.33333 17.4674 3.50893 17.1548 3.82149C16.8423 4.13405 16.6667 4.55797 16.6667 5C16.6667 5.44203 16.4911 5.86595 16.1785 6.17851C15.866 6.49107 15.442 6.66667 15 6.66667H13.3333C12.0073 6.66667 10.7355 7.19345 9.7978 8.13113C8.86012 9.06881 8.33333 10.3406 8.33333 11.6667V31.6667C8.33333 32.9927 8.86012 34.2645 9.7978 35.2022C10.7355 36.1399 12.0073 36.6667 13.3333 36.6667H26.6667C27.9927 36.6667 29.2645 36.1399 30.2022 35.2022C31.1399 34.2645 31.6667 32.9927 31.6667 31.6667V11.6667Z"
                    fill="#202020"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1826_200">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p className="tabTitle"> {props.tabTitle1}</p>
            <TransparentRoundedBtn
              rName="rAnimeBtn expertBtn"
              rLink=""
              rText="button title"
            />
          </div>
          <div
            className={`tabs tabs2 ${isActive === 2 ? "activeTab" : ""}`}
            onClick={() => handleActive(2)}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <g clipPath="url(#clip0_1840_204)">
                  <path
                    d="M38.6733 23.9733L29.795 7.29167C27.33 2.79833 22.07 0.681667 17.2433 2.105C15.4467 0.781667 13.23 0 10.8333 0C4.86 0 0 4.86 0 10.8333V29.1667C0 35.14 4.86 40 10.8333 40C14.6867 40 18.0767 37.9767 19.9983 34.9367C21.4083 37.1833 23.565 38.815 26.1333 39.565C27.1383 39.8583 28.1633 40.0033 29.1817 40.0033C30.9783 40.0033 32.7567 39.5517 34.3767 38.6633C36.9133 37.2717 38.7567 34.9767 39.5683 32.1983C40.3783 29.42 40.0583 26.4933 38.6767 23.9733H38.6733ZM26.8617 8.87667L30.65 15.9933L21.6667 20.92V10.8317C21.6667 8.68833 21.0417 6.68833 19.9633 5.005C22.745 4.88333 25.4633 6.325 26.8633 8.875L26.8617 8.87667ZM10.8333 3.33333C14.9683 3.33333 18.3333 6.69833 18.3333 10.8333V18.3333H3.33333V10.8333C3.33333 6.69833 6.69833 3.33333 10.8333 3.33333ZM10.8333 36.6667C6.69833 36.6667 3.33333 33.3017 3.33333 29.1667V21.6667H18.3333V29.1667C18.3333 33.3017 14.9683 36.6667 10.8333 36.6667ZM36.365 31.265C35.8033 33.1883 34.5267 34.7783 32.77 35.7417C31.0133 36.705 28.985 36.925 27.065 36.3667C25.1417 35.805 23.5517 34.5283 22.5983 32.79L21.5417 30.8067C21.6233 30.2717 21.665 29.725 21.665 29.1683V24.725L32.215 18.94L35.7383 25.56C36.7017 27.3167 36.9233 29.3433 36.3633 31.2667L36.365 31.265Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1840_204">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p className="tabTitle"> {props.tabTitle2}</p>
            <TransparentRoundedBtn
              rName="rAnimeBtn expertBtn"
              rLink=""
              rText="button"
            />
          </div>
          <div
            className={`tabs tabs3 ${isActive === 3 ? "activeTab" : ""}`}
            onClick={() => handleActive(3)}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <g clipPath="url(#clip0_1767_6696)">
                  <path
                    d="M16.6667 38.3333C16.6667 39.255 15.9217 40 15 40H8.33333C3.73833 40 0 36.2617 0 31.6667V8.33333C0 3.73833 3.73833 0 8.33333 0H21.6667C26.2617 0 30 3.73833 30 8.33333V11.6667C30 12.5883 29.255 13.3333 28.3333 13.3333C27.4117 13.3333 26.6667 12.5883 26.6667 11.6667V8.33333C26.6667 5.57667 24.4233 3.33333 21.6667 3.33333H8.33333C5.57667 3.33333 3.33333 5.57667 3.33333 8.33333V31.6667C3.33333 34.4233 5.57667 36.6667 8.33333 36.6667H15C15.9217 36.6667 16.6667 37.4117 16.6667 38.3333ZM23.3333 10C23.3333 9.07833 22.5883 8.33333 21.6667 8.33333H8.33333C7.41167 8.33333 6.66667 9.07833 6.66667 10C6.66667 10.9217 7.41167 11.6667 8.33333 11.6667H21.6667C22.5883 11.6667 23.3333 10.9217 23.3333 10ZM16.6667 18.3333C16.6667 17.4117 15.9217 16.6667 15 16.6667H8.33333C7.41167 16.6667 6.66667 17.4117 6.66667 18.3333C6.66667 19.255 7.41167 20 8.33333 20H15C15.9217 20 16.6667 19.255 16.6667 18.3333ZM8.33333 25C7.41167 25 6.66667 25.745 6.66667 26.6667C6.66667 27.5883 7.41167 28.3333 8.33333 28.3333H11.6667C12.5883 28.3333 13.3333 27.5883 13.3333 26.6667C13.3333 25.745 12.5883 25 11.6667 25H8.33333ZM40 28.3333C40 34.765 34.765 40 28.3333 40C21.9017 40 16.6667 34.765 16.6667 28.3333C16.6667 21.9017 21.9017 16.6667 28.3333 16.6667C34.765 16.6667 40 21.9017 40 28.3333ZM36.6667 28.3333C36.6667 23.7383 32.9283 20 28.3333 20C23.7383 20 20 23.7383 20 28.3333C20 32.9283 23.7383 36.6667 28.3333 36.6667C32.9283 36.6667 36.6667 32.9283 36.6667 28.3333ZM31.3467 26.265L27.6417 29.8217C27.4017 30.0567 27.01 30.0617 26.7717 29.825L24.8867 27.9783C24.2267 27.3317 23.1733 27.3417 22.53 28.0017C21.885 28.66 21.895 29.7133 22.5533 30.3583L24.44 32.2067C25.2067 32.955 26.21 33.33 27.2117 33.33C28.2133 33.33 29.2133 32.955 29.9667 32.2117L33.655 28.6717C34.3183 28.0333 34.34 26.9783 33.7033 26.315C33.065 25.6483 32.0083 25.63 31.3467 26.2667V26.265Z"
                    fill="#202020"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1767_6696">
                    <rect width="40" height="40" fill="#fff" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p className="tabTitle"> {props.tabTitle3}</p>
            <TransparentRoundedBtn
              rName="rAnimeBtn expertBtn"
              rLink=""
              rText="button"
            />
          </div>
          <div
            className={`tabs tabs4 ${isActive === 4 ? "activeTab" : ""}`}
            onClick={() => handleActive(4)}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <g clipPath="url(#clip0_1767_6700)">
                  <path
                    d="M26.6667 40H13.3333C8.73833 40 5 36.2617 5 31.6667V11.6667C5 7.07167 8.73833 3.33333 13.3333 3.33333H13.6183C14.3067 1.39333 16.16 0 18.3333 0H21.6667C23.84 0 25.6933 1.39333 26.3817 3.33333H26.6667C31.2617 3.33333 35 7.07167 35 11.6667V31.6667C35 36.2617 31.2617 40 26.6667 40ZM13.3333 6.66667C10.5767 6.66667 8.33333 8.91 8.33333 11.6667V31.6667C8.33333 34.4233 10.5767 36.6667 13.3333 36.6667H26.6667C29.4233 36.6667 31.6667 34.4233 31.6667 31.6667V11.6667C31.6667 8.91 29.4233 6.66667 26.6667 6.66667H25C24.08 6.66667 23.3333 5.92 23.3333 5C23.3333 4.08 22.585 3.33333 21.6667 3.33333H18.3333C17.415 3.33333 16.6667 4.08167 16.6667 5C16.6667 5.91833 15.92 6.66667 15 6.66667H13.3333ZM20 21.6667C22.3017 21.6667 24.1667 19.8017 24.1667 17.5C24.1667 15.1983 22.3017 13.3333 20 13.3333C17.6983 13.3333 15.8333 15.1983 15.8333 17.5C15.8333 19.8017 17.6983 21.6667 20 21.6667ZM27.0817 31.6133C27.9733 31.385 28.51 30.475 28.28 29.585C27.3483 25.9633 23.8667 23.3333 20 23.3333C16.1333 23.3333 12.6517 25.9633 11.72 29.585C11.49 30.4767 12.0267 31.385 12.9183 31.6133C13.8133 31.8433 14.7183 31.3067 14.9467 30.415C15.4967 28.2783 17.6683 26.6667 20 26.6667C22.3317 26.6667 24.5033 28.2783 25.0533 30.415C25.2467 31.1683 25.9233 31.6667 26.6667 31.6667C26.8033 31.6667 26.9417 31.65 27.0817 31.6133Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1767_6700">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p className="tabTitle"> {props.tabTitle4}</p>
            <TransparentRoundedBtn
              rName="rAnimeBtn expertBtn"
              rLink=""
              rText="button"
            />
          </div>
        </div>
        <div className="mobTabsButnWrap col-lg-6 col-md-12 d-flex d-md-none">
          <div
            className={`tabs tabs1 ${isActive === 1 ? "activeTab" : ""}`}
            onClick={() => handleActive(1)}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <g clipPath="url(#clip0_1826_200)">
                  <path
                    d="M15 15C15 14.558 15.1756 14.134 15.4882 13.8215C15.8007 13.5089 16.2246 13.3333 16.6667 13.3333H18.3333V11.6667C18.3333 11.2246 18.5089 10.8007 18.8215 10.4882C19.134 10.1756 19.558 10 20 10C20.442 10 20.8659 10.1756 21.1785 10.4882C21.4911 10.8007 21.6667 11.2246 21.6667 11.6667V13.3333H23.3333C23.7754 13.3333 24.1993 13.5089 24.5118 13.8215C24.8244 14.134 25 14.558 25 15C25 15.442 24.8244 15.8659 24.5118 16.1785C24.1993 16.4911 23.7754 16.6667 23.3333 16.6667H21.6667V18.3333C21.6667 18.7754 21.4911 19.1993 21.1785 19.5118C20.8659 19.8244 20.442 20 20 20C19.558 20 19.134 19.8244 18.8215 19.5118C18.5089 19.1993 18.3333 18.7754 18.3333 18.3333V16.6667H16.6667C16.2246 16.6667 15.8007 16.4911 15.4882 16.1785C15.1756 15.8659 15 15.442 15 15ZM26.6667 23.3333H13.3333C12.8913 23.3333 12.4674 23.5089 12.1548 23.8215C11.8423 24.134 11.6667 24.558 11.6667 25C11.6667 25.442 11.8423 25.8659 12.1548 26.1785C12.4674 26.4911 12.8913 26.6667 13.3333 26.6667H26.6667C27.1087 26.6667 27.5326 26.4911 27.8452 26.1785C28.1577 25.8659 28.3333 25.442 28.3333 25C28.3333 24.558 28.1577 24.134 27.8452 23.8215C27.5326 23.5089 27.1087 23.3333 26.6667 23.3333ZM20 30H13.3333C12.8913 30 12.4674 30.1756 12.1548 30.4882C11.8423 30.8007 11.6667 31.2246 11.6667 31.6667C11.6667 32.1087 11.8423 32.5326 12.1548 32.8452C12.4674 33.1577 12.8913 33.3333 13.3333 33.3333H20C20.442 33.3333 20.8659 33.1577 21.1785 32.8452C21.4911 32.5326 21.6667 32.1087 21.6667 31.6667C21.6667 31.2246 21.4911 30.8007 21.1785 30.4882C20.8659 30.1756 20.442 30 20 30ZM35 11.6667V31.6667C34.9974 33.876 34.1185 35.9941 32.5563 37.5563C30.9941 39.1185 28.876 39.9974 26.6667 40H13.3333C11.124 39.9974 9.00593 39.1185 7.4437 37.5563C5.88147 35.9941 5.00265 33.876 5 31.6667V11.6667C5.00265 9.45734 5.88147 7.33926 7.4437 5.77703C9.00593 4.2148 11.124 3.33598 13.3333 3.33333H13.6183C13.9643 2.35915 14.6032 1.51585 15.4473 0.919072C16.2915 0.322293 17.2995 0.00126125 18.3333 0L21.6667 0C22.7005 0.00126125 23.7085 0.322293 24.5527 0.919072C25.3968 1.51585 26.0357 2.35915 26.3817 3.33333H26.6667C28.876 3.33598 30.9941 4.2148 32.5563 5.77703C34.1185 7.33926 34.9974 9.45734 35 11.6667ZM31.6667 11.6667C31.6667 10.3406 31.1399 9.06881 30.2022 8.13113C29.2645 7.19345 27.9927 6.66667 26.6667 6.66667H25C24.558 6.66667 24.134 6.49107 23.8215 6.17851C23.5089 5.86595 23.3333 5.44203 23.3333 5C23.3333 4.55797 23.1577 4.13405 22.8452 3.82149C22.5326 3.50893 22.1087 3.33333 21.6667 3.33333H18.3333C17.8913 3.33333 17.4674 3.50893 17.1548 3.82149C16.8423 4.13405 16.6667 4.55797 16.6667 5C16.6667 5.44203 16.4911 5.86595 16.1785 6.17851C15.866 6.49107 15.442 6.66667 15 6.66667H13.3333C12.0073 6.66667 10.7355 7.19345 9.7978 8.13113C8.86012 9.06881 8.33333 10.3406 8.33333 11.6667V31.6667C8.33333 32.9927 8.86012 34.2645 9.7978 35.2022C10.7355 36.1399 12.0073 36.6667 13.3333 36.6667H26.6667C27.9927 36.6667 29.2645 36.1399 30.2022 35.2022C31.1399 34.2645 31.6667 32.9927 31.6667 31.6667V11.6667Z"
                    fill="#202020"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1826_200">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p className="tabTitle"> {props.tabTitle1}</p>
            <TransparentRoundedBtn
              rName="rAnimeBtn expertBtn"
              rLink=""
              rText="button title"
            />
          </div>
          <div
            className={`tabs tabs2 ${isActive === 2 ? "activeTab" : ""}`}
            onClick={() => handleActive(2)}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <g clipPath="url(#clip0_1840_204)">
                  <path
                    d="M38.6733 23.9733L29.795 7.29167C27.33 2.79833 22.07 0.681667 17.2433 2.105C15.4467 0.781667 13.23 0 10.8333 0C4.86 0 0 4.86 0 10.8333V29.1667C0 35.14 4.86 40 10.8333 40C14.6867 40 18.0767 37.9767 19.9983 34.9367C21.4083 37.1833 23.565 38.815 26.1333 39.565C27.1383 39.8583 28.1633 40.0033 29.1817 40.0033C30.9783 40.0033 32.7567 39.5517 34.3767 38.6633C36.9133 37.2717 38.7567 34.9767 39.5683 32.1983C40.3783 29.42 40.0583 26.4933 38.6767 23.9733H38.6733ZM26.8617 8.87667L30.65 15.9933L21.6667 20.92V10.8317C21.6667 8.68833 21.0417 6.68833 19.9633 5.005C22.745 4.88333 25.4633 6.325 26.8633 8.875L26.8617 8.87667ZM10.8333 3.33333C14.9683 3.33333 18.3333 6.69833 18.3333 10.8333V18.3333H3.33333V10.8333C3.33333 6.69833 6.69833 3.33333 10.8333 3.33333ZM10.8333 36.6667C6.69833 36.6667 3.33333 33.3017 3.33333 29.1667V21.6667H18.3333V29.1667C18.3333 33.3017 14.9683 36.6667 10.8333 36.6667ZM36.365 31.265C35.8033 33.1883 34.5267 34.7783 32.77 35.7417C31.0133 36.705 28.985 36.925 27.065 36.3667C25.1417 35.805 23.5517 34.5283 22.5983 32.79L21.5417 30.8067C21.6233 30.2717 21.665 29.725 21.665 29.1683V24.725L32.215 18.94L35.7383 25.56C36.7017 27.3167 36.9233 29.3433 36.3633 31.2667L36.365 31.265Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1840_204">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p className="tabTitle"> {props.tabTitle2}</p>
            <TransparentRoundedBtn
              rName="rAnimeBtn expertBtn"
              rLink=""
              rText="button"
            />
          </div>
          <div
            className={`tabs tabs3 ${isActive === 3 ? "activeTab" : ""}`}
            onClick={() => handleActive(3)}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <g clipPath="url(#clip0_1767_6696)">
                  <path
                    d="M16.6667 38.3333C16.6667 39.255 15.9217 40 15 40H8.33333C3.73833 40 0 36.2617 0 31.6667V8.33333C0 3.73833 3.73833 0 8.33333 0H21.6667C26.2617 0 30 3.73833 30 8.33333V11.6667C30 12.5883 29.255 13.3333 28.3333 13.3333C27.4117 13.3333 26.6667 12.5883 26.6667 11.6667V8.33333C26.6667 5.57667 24.4233 3.33333 21.6667 3.33333H8.33333C5.57667 3.33333 3.33333 5.57667 3.33333 8.33333V31.6667C3.33333 34.4233 5.57667 36.6667 8.33333 36.6667H15C15.9217 36.6667 16.6667 37.4117 16.6667 38.3333ZM23.3333 10C23.3333 9.07833 22.5883 8.33333 21.6667 8.33333H8.33333C7.41167 8.33333 6.66667 9.07833 6.66667 10C6.66667 10.9217 7.41167 11.6667 8.33333 11.6667H21.6667C22.5883 11.6667 23.3333 10.9217 23.3333 10ZM16.6667 18.3333C16.6667 17.4117 15.9217 16.6667 15 16.6667H8.33333C7.41167 16.6667 6.66667 17.4117 6.66667 18.3333C6.66667 19.255 7.41167 20 8.33333 20H15C15.9217 20 16.6667 19.255 16.6667 18.3333ZM8.33333 25C7.41167 25 6.66667 25.745 6.66667 26.6667C6.66667 27.5883 7.41167 28.3333 8.33333 28.3333H11.6667C12.5883 28.3333 13.3333 27.5883 13.3333 26.6667C13.3333 25.745 12.5883 25 11.6667 25H8.33333ZM40 28.3333C40 34.765 34.765 40 28.3333 40C21.9017 40 16.6667 34.765 16.6667 28.3333C16.6667 21.9017 21.9017 16.6667 28.3333 16.6667C34.765 16.6667 40 21.9017 40 28.3333ZM36.6667 28.3333C36.6667 23.7383 32.9283 20 28.3333 20C23.7383 20 20 23.7383 20 28.3333C20 32.9283 23.7383 36.6667 28.3333 36.6667C32.9283 36.6667 36.6667 32.9283 36.6667 28.3333ZM31.3467 26.265L27.6417 29.8217C27.4017 30.0567 27.01 30.0617 26.7717 29.825L24.8867 27.9783C24.2267 27.3317 23.1733 27.3417 22.53 28.0017C21.885 28.66 21.895 29.7133 22.5533 30.3583L24.44 32.2067C25.2067 32.955 26.21 33.33 27.2117 33.33C28.2133 33.33 29.2133 32.955 29.9667 32.2117L33.655 28.6717C34.3183 28.0333 34.34 26.9783 33.7033 26.315C33.065 25.6483 32.0083 25.63 31.3467 26.2667V26.265Z"
                    fill="#202020"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1767_6696">
                    <rect width="40" height="40" fill="#fff" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p className="tabTitle"> {props.tabTitle3}</p>
            <TransparentRoundedBtn
              rName="rAnimeBtn expertBtn"
              rLink=""
              rText="button"
            />
          </div>
          <div
            className={`tabs tabs4 ${isActive === 4 ? "activeTab" : ""}`}
            onClick={() => handleActive(4)}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <g clipPath="url(#clip0_1767_6700)">
                  <path
                    d="M26.6667 40H13.3333C8.73833 40 5 36.2617 5 31.6667V11.6667C5 7.07167 8.73833 3.33333 13.3333 3.33333H13.6183C14.3067 1.39333 16.16 0 18.3333 0H21.6667C23.84 0 25.6933 1.39333 26.3817 3.33333H26.6667C31.2617 3.33333 35 7.07167 35 11.6667V31.6667C35 36.2617 31.2617 40 26.6667 40ZM13.3333 6.66667C10.5767 6.66667 8.33333 8.91 8.33333 11.6667V31.6667C8.33333 34.4233 10.5767 36.6667 13.3333 36.6667H26.6667C29.4233 36.6667 31.6667 34.4233 31.6667 31.6667V11.6667C31.6667 8.91 29.4233 6.66667 26.6667 6.66667H25C24.08 6.66667 23.3333 5.92 23.3333 5C23.3333 4.08 22.585 3.33333 21.6667 3.33333H18.3333C17.415 3.33333 16.6667 4.08167 16.6667 5C16.6667 5.91833 15.92 6.66667 15 6.66667H13.3333ZM20 21.6667C22.3017 21.6667 24.1667 19.8017 24.1667 17.5C24.1667 15.1983 22.3017 13.3333 20 13.3333C17.6983 13.3333 15.8333 15.1983 15.8333 17.5C15.8333 19.8017 17.6983 21.6667 20 21.6667ZM27.0817 31.6133C27.9733 31.385 28.51 30.475 28.28 29.585C27.3483 25.9633 23.8667 23.3333 20 23.3333C16.1333 23.3333 12.6517 25.9633 11.72 29.585C11.49 30.4767 12.0267 31.385 12.9183 31.6133C13.8133 31.8433 14.7183 31.3067 14.9467 30.415C15.4967 28.2783 17.6683 26.6667 20 26.6667C22.3317 26.6667 24.5033 28.2783 25.0533 30.415C25.2467 31.1683 25.9233 31.6667 26.6667 31.6667C26.8033 31.6667 26.9417 31.65 27.0817 31.6133Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1767_6700">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p className="tabTitle"> {props.tabTitle4}</p>
            <TransparentRoundedBtn
              rName="rAnimeBtn expertBtn"
              rLink=""
              rText="button"
            />
          </div>
        </div>
      </div>
      <div className="col-lg-6 col-md-12">
        <div className="rightHealthTabBox">
          {isActive === 1 && (
            <div className="healthTabContentBox">
              <h5>{props.tabContentTitle11}</h5>
              <ul className="supportList">
                {props.contentList11 && <li>{props.contentList11}</li>}
                {props.contentList12 && <li>{props.contentList12}</li>}
                {props.contentList13 && <li>{props.contentList13}</li>}
                {props.contentList14 && <li>{props.contentList14}</li>}
                {props.contentList15 && <li>{props.contentList15}</li>}
                {props.contentList16 && <li>{props.contentList16}</li>}
                {props.contentList17 && <li>{props.contentList17}</li>}
                {props.contentList18 && <li>{props.contentList18}</li>}
              </ul>
            </div>
          )}
          {isActive === 2 && (
            <div className="healthTabContentBox">
              <h5>{props.tabContentTitle22}</h5>
              <ul className="supportList">
                {props.contentList21 && <li>{props.contentList21}</li>}
                {props.contentList22 && <li>{props.contentList22}</li>}
                {props.contentList23 && <li>{props.contentList23}</li>}
                {props.contentList24 && <li>{props.contentList24}</li>}
                {props.contentList25 && <li>{props.contentList25}</li>}
                {props.contentList26 && <li>{props.contentList26}</li>}
                {props.contentList27 && <li>{props.contentList27}</li>}
                {props.contentList28 && <li>{props.contentList28}</li>}
              </ul>
            </div>
          )}
          {isActive === 3 && (
            <div className="healthTabContentBox">
              <h5>{props.tabContentTitle33}</h5>
              <ul className="supportList">
                {props.contentList31 && <li>{props.contentList31}</li>}
                {props.contentList32 && <li>{props.contentList32}</li>}
                {props.contentList33 && <li>{props.contentList33}</li>}
                {props.contentList34 && <li>{props.contentList34}</li>}
                {props.contentList35 && <li>{props.contentList35}</li>}
                {props.contentList36 && <li>{props.contentList36}</li>}
                {props.contentList37 && <li>{props.contentList37}</li>}
                {props.contentList38 && <li>{props.contentList38}</li>}
              </ul>
            </div>
          )}
          {isActive === 4 && (
            <div className="healthTabContentBox">
              <h5>{props.tabContentTitle44}</h5>
              <ul className="supportList">
                {props.contentList41 && <li>{props.contentList41}</li>}
                {props.contentList42 && <li>{props.contentList42}</li>}
                {props.contentList43 && <li>{props.contentList43}</li>}
                {props.contentList44 && <li>{props.contentList44}</li>}
                {props.contentList45 && <li>{props.contentList45}</li>}
                {props.contentList46 && <li>{props.contentList46}</li>}
                {props.contentList47 && <li>{props.contentList47}</li>}
                {props.contentList48 && <li>{props.contentList48}</li>}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HealthcareTabs;
